import { useEffect, useRef, DependencyList } from 'react';

/**
 * 初回レンダリング時に実行したくない処理用のカスタムフック
 */
export const useUpdateEffect = (callback: () => void, dependencies: DependencyList) => {
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}

		return callback();
	}, dependencies);
};
